if (!customElements.get('product-form')) {
    
  
  customElements.define('product-form', class ProductForm extends HTMLElement {
                        
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      //console.log("this.cartNotification", this.cartNotification);
  	}
    
    onSubmitHandler(evt) {
      
      evt.preventDefault();
  
      const submitButton = this.querySelector('[type="submit"]');
      //console.log("submitButton", submitButton)
      if (submitButton.classList.contains('loading')) return;
            
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);      
      
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      //console.log(this.cartNotification.getSectionsToRender().map((section) => section.id))
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
            
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        
       	  let responseNeeded = response;
          //console.log("responseNeeded", response)
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
			
          let cartObject;
        
          //Apo edw tha parw kai ton arithmo twn cart items kathws kai to cart total price
        
          (async() => {  
            let getAllCart = await this.getCartJson();
				    cartObject = getAllCart;
            //console.log('cartObject', cartObject)
            this.cartNotification.open();
          })()
      	     
          setTimeout(() => {       
            //this.cartNotification.renderContents(cartObject, responseNeeded);
            //console.log(this.cartNotification)
            document.querySelector('.cart-count-bubble span:first-child').textContent = `${cartObject.item_count}`
          }, 500);
    
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');            	 
        });
 
    }


    async getCartJson() {
      const result = await fetch("/cart.json");
      if (result.status === 200) {
        return result.json();
      }
      throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`); 
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        if(errorMessage.includes('Και τα 1')) {
          errorMessage = errorMessage.replace('τα', 'το')
          this.errorMessage.textContent = errorMessage;
        } else {
          this.errorMessage.textContent = errorMessage;
        }
      }

    }

  });




}
